import { React, useState } from "react";

function Order_payment_gateway({ options = [], handleChangeData }) {
  // useEffect(() => {
  //   document.querySelectorAll(".gateway-label").forEach((eachLabelElem) =>
  //     eachLabelElem.addEventListener("click", function (elm) {
  //       var pr = document.querySelectorAll(".gateway");
  //       [].forEach.call(pr, function (el) {
  //         el.classList.remove("active");
  //       });
  //       const parent = elm.target.closest(".gateway");
  //       parent.classList.add("active");
  //     })
  //   );
  // }, []);

  const [value, setValue] = useState(null);

  const handleChange = (value) => {
    setValue(value);
    handleChangeData({ payment_gateway: value });
  };
  return (
    <div className="form-item payment-gateway">
      <div className="right">
        <label htmlFor="order_payment_gateway">
          <i className="far fa-credit-card"></i>
          درگاه پرداخت
        </label>
      </div>
      <div className="left">
        {options.map((option, index) => (
          <div
            key={index}
            className={
              value === option.unique_name ? "gateway active" : "gateway"
            }
            onClick={() => {
              handleChange(option.unique_name);
            }}
          >
            <input
              type="radio"
              name="payment-gateway"
              id={option.unique_name}
              value={option.unique_name}
            />
            <label htmlFor="mellat" className="gateway-label">
              <img
                src={option.photo}
                alt={option.title}
                title={option.title}
                className="img-fluid"
              />
            </label>
          </div>
        ))}
        {/* <div className="gateway">
          <input
            type="radio"
            name="payment-gateway"
            id="mellat"
            value="mellat"
          />
          <label htmlFor="mellat" className="gateway-label">
            <img
              src={process.env.PUBLIC_URL + "/images/mellat.png"}
              alt="بانک ملت"
              title="بانک ملت"
              className="img-fluid"
            />
          </label>
        </div>
        <div className="gateway">
          <input type="radio" name="payment-gateway" id="saman" value="saman" />
          <label htmlFor="saman" className="gateway-label">
            <img
              src={process.env.PUBLIC_URL + "/images/saman.png"}
              alt="بانک سامان"
              title="بانک سامان"
              className="img-fluid"
            />
          </label>
        </div>
        <div className="gateway">
          <input
            type="radio"
            name="payment-gateway"
            id="parsian"
            value="parsian"
          />
          <label htmlFor="parsian" className="gateway-label">
            <img
              src={process.env.PUBLIC_URL + "/images/parsian.png"}
              alt="بانک پارسیان"
              title="بانک پارسیان"
              className="img-fluid"
            />
          </label>
        </div> */}
        <div className="desc">
          <h4>پرداخت از طریق کلیه کارت های عضو شتاب امکان پذیر است.</h4>
          <p>قبل از پرداخت از خاموش بودن فیلترشکن خود مطمئن شوید.</p>
        </div>
      </div>
    </div>
  );
}

export default Order_payment_gateway;
